import { render, staticRenderFns } from "./RTPListBack.vue?vue&type=template&id=4e76224e&"
import script from "./RTPListBack.vue?vue&type=script&lang=js&"
export * from "./RTPListBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports